// src/components/Formulario.js
import { Form, Button } from "react-bootstrap";
import { useEffect, useState } from "react";

import check from "../../assets/img/check.png";
import loadingImg from "../../assets/img/preload.gif";
import { useParams } from "react-router-dom";
import { sendPostRequest } from "../../config/desol";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { sendToTecnom } from "../../config/tecnomApi";
import { getUtmParams, saveUtmParams } from "../../config/whatsappConfig";

const Formulario = () => {
  // Constante para pausar el envío a DESOL (cambiar a false para habilitar)
  const ENABLE_DESOL_SEND = false;

  const [validated, setValidated] = useState(false);
  const [status, setStatus] = useState(null);
  const { slug } = useParams();
  const query = new URLSearchParams(window.location.search);
  const utmParams = getUtmParams();
  const utm_medium = utmParams.utm_medium || "";
  const utm_source = utmParams.utm_source || "";
  const utm_campaign = utmParams.utm_campaign || "";
  const utm_content = utmParams.utm_content || "";
  const utm_term = utmParams.utm_term || "";
  const utm_id = utmParams.utm_id || "";
  const utm_brand = utmParams.utm_brand || "";
  const brand_param = query?.get("brand");

  const [errors, setErrors] = useState({ email: "", phone: "" });
  const { updateData } = useFirestoreUpdate("medios-off", "datos");
  const [medio, setMedio] = useState(slug);

  const [desolChannel, setDesolChannel] = useState("");

  // Función para construir URLs de WhatsApp con UTM de la URL cuando estén disponibles
  const buildWhatsAppUrl = (brand) => {
    const phoneNumbers = {
      FORD: "5493513527817",
      FIAT: "5493513525903",
      PEUGEOT: "5493513793585",
      JEEP: "5493513743833",
      HYUNDAI: "5493517385093",
      GAC: "5493517915736",
    };

    const phone = phoneNumbers[brand] || phoneNumbers.HYUNDAI;

    const trackingParams = new URLSearchParams();
    trackingParams.append("utm_source", utm_source);
    trackingParams.append("utm_medium", utm_medium);
    if (utm_campaign) trackingParams.append("utm_campaign", utm_campaign);
    if (utm_content) trackingParams.append("utm_content", utm_content);

    const trackingUrl = `https://oficial.montironi.com/consultas/?${trackingParams.toString()}`;
    const message = `Hola, me gustaría hacer una consulta.\n${trackingUrl}`;

    const baseUrl = "https://api.whatsapp.com/send";
    const params = new URLSearchParams({ phone, text: message });
    return `${baseUrl}?${params.toString()}`;
  };

  // URLs de WhatsApp por marca (construidas dinámicamente)
  const whatsappUrls = {
    FORD: buildWhatsAppUrl("FORD"),
    FIAT: buildWhatsAppUrl("FIAT"),
    PEUGEOT: buildWhatsAppUrl("PEUGEOT"),
    JEEP: buildWhatsAppUrl("JEEP"),
    HYUNDAI: buildWhatsAppUrl("HYUNDAI"),
    GAC: buildWhatsAppUrl("GAC"),
  };

  // Keep your data in "toSend", just change the fields to match your new design
  const [toSend, setToSend] = useState({
    name: "", // Nombre y apellido
    email: "", // Correo electrónico
    phone: "", // Nº de celular
    medio: "", // ¿Cómo llegaste a nuestro sitio?
    brand: "", // ¿Qué marca te interesa?
    acquisition: "", // ¿Cómo te gustaría adquirir tu auto?
    origen: `${medio ? medio : ""} ${utm_medium ? utm_medium : ""}`,
    utm_medium: utm_medium || "", // Medium de campaña UTM
    utm_source: utm_source || "", // Source de campaña UTM
    utm_campaign: utm_campaign || "", // Campaña UTM (mismo que para WhatsApp)
    utm_content: utm_content || "", // Content UTM
  });

  //DESOL CHANNELS
  const defineChannel = (brand, acquisition) => {
    if (brand === "FORD") {
      if (acquisition === "Plan") {
        setDesolChannel("C12_FORD_LANDINGS");
      } else {
        setDesolChannel("C12_FORD_LANDINGS");
      }
    } else {
      setDesolChannel("C12_FIAT_JEEP_PEUGEOT_LANDINGS");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setToSend({ ...toSend, [name]: value });

    // Validate email on change
    if (name === "email") {
      validateEmail(value);
    }

    // Validate email on change
    if (name === "phone") {
      validatePhone(value);
    }

    if (name === "brand") {
      defineChannel(value, toSend.acquisition);
      // Guardar la marca seleccionada en sessionStorage para que persista en el modal de WhatsApp
      if (value) {
        const brandMapping = {
          FORD: "ford",
          FIAT: "fiat",
          PEUGEOT: "peugeot",
          JEEP: "jeep",
          HYUNDAI: "hyundai",
          GAC: "gac",
        };
        const brandLower = brandMapping[value] || value.toLowerCase();
        sessionStorage.setItem("selectedBrand", brandLower);

        // Console.log para verificar el link de WhatsApp según la marca seleccionada
        const selectedUrl = whatsappUrls[value];
        if (selectedUrl) {
          console.log(`🔗 [Formulario Principal] Marca seleccionada: ${value}`);
          console.log(`📱 URL de WhatsApp:`, selectedUrl);
        }
      }
    }

    if (name === "acquisition") {
      defineChannel(toSend.brand, value);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior at the start
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }
    setValidated(true);
    if (form.checkValidity() === true) {
      e.preventDefault();

      setStatus("cargando");
      setValidated(true);

      const data = {
        Apellido: toSend.name,
        Email: toSend.email,
        Telefono: toSend.phone,
        Canal: toSend.acquisition === "Plan" ? "Plan de ahorro" : "Venta directa",
        Motivo: desolChannel,
        OrigenLead: `${process.env.REACT_APP_LANDING} - ${medio ? medio : "Medio sin especificar"}`,
        CommercialCampaign: utm_medium ? utm_medium : "",
        Campaign: desolChannel,
        Modelo_Pedido: toSend.brand,
        utm_source: utm_source || "",
        utm_medium: utm_medium || "",
        utm_campaign: utm_campaign || "",
        utm_term: utm_term || "",
        utm_content: utm_content || "",
        utm_id: utm_id || "",
        utm_brand: utm_brand || "",
      };

      console.log(data);

      // EMAIL JS (ONLY FOR BACKUP)
      //emailjs.send("landingMontironi", tipoTemplate, toSend, "user_EIC1ELQk7I3NPaFMEDa64");

      //SAVE TO FIRESTORE
      await updateData(data);

      console.log("toSend", toSend);

      // Enviar a Tecnóm
      try {
        await sendToTecnom(toSend);
        console.log("Datos enviados exitosamente a Tecnóm");
      } catch (tecnomError) {
        console.error("Error al enviar a Tecnóm:", tecnomError);
        // No interrumpir el flujo si falla Tecnóm, continuar con DESOL
      }

      //API DESOL (pausada para testing)
      if (ENABLE_DESOL_SEND) {
        sendPostRequest(process.env.REACT_APP_DESOL_URL, data)
          .then((response) => {
            // Redirigir a WhatsApp según la marca seleccionada
            const whatsappUrl = whatsappUrls[toSend.brand];
            if (whatsappUrl) {
              window.location.href = whatsappUrl;
            } else {
              setStatus("error");
              setTimeout(() => {
                setStatus(null);
              }, 10000);
            }
          })
          .catch((error) => {
            // Aún así redirigir a WhatsApp si falla DESOL
            const whatsappUrl = whatsappUrls[toSend.brand];
            if (whatsappUrl) {
              window.location.href = whatsappUrl;
            } else {
              setStatus("error");
              setTimeout(() => {
                setStatus(null);
              }, 10000);
            }
          });
      } else {
        //console.log("🚫 DESOL pausado para testing - solo se envió a Tecnóm");
        // Redirigir a WhatsApp según la marca seleccionada
        const whatsappUrl = whatsappUrls[toSend.brand];
        if (whatsappUrl) {
          window.location.href = whatsappUrl;
          //console.log("Redirigiendo a WhatsApp según la marca seleccionada", whatsappUrl);
        } else {
          setStatus("error");
          setTimeout(() => {
            setStatus(null);
          }, 10000);
        }
      }
    }
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!emailPattern.test(email)) {
      setErrors({ ...errors, email: "Email debe tener el formato: ejemplo@ejemplo.com" });
    } else {
      setErrors({ ...errors, email: "" });
    }
  };

  const validatePhone = (phone) => {
    const phonePattern = /^\d{10}$/;
    if (!phonePattern.test(phone)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: "Solo números, sin 0 y sin 15. Ej. 351 5 123456",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
    }
  };
  const handleKeyDown = (event) => {
    // Allow: backspace, delete, tab, escape, enter, and arrow keys
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "Escape",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];
    if (allowedKeys.includes(event.key)) return;

    // Prevent default if not a number
    if (!/^\d+$/.test(event.key)) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    setMedio(slug);
  }, [slug]);

  // Persistir UTM de la URL en sessionStorage para usarlos al construir el link de WhatsApp
  useEffect(() => {
    saveUtmParams();
  }, []);

  // Autoseleccionar marca desde parámetro UTM brand
  useEffect(() => {
    // Obtener el valor de utm_brand o brand de la URL
    const brandFromUrl = utm_brand || brand_param;

    if (brandFromUrl) {
      // Mapeo de valores en minúsculas a valores en mayúsculas del formulario
      const brandMapping = {
        peugeot: "PEUGEOT",
        fiat: "FIAT",
        ford: "FORD",
        hyundai: "HYUNDAI",
        jeep: "JEEP",
        gac: "GAC",
        // También manejar valores que ya vengan en mayúsculas
        PEUGEOT: "PEUGEOT",
        FIAT: "FIAT",
        FORD: "FORD",
        HYUNDAI: "HYUNDAI",
        JEEP: "JEEP",
        GAC: "GAC",
      };

      const normalizedBrand = brandFromUrl.toLowerCase();
      const mappedBrand = brandMapping[normalizedBrand] || brandMapping[brandFromUrl];

      if (mappedBrand) {
        setToSend((prev) => {
          // Solo actualizar si no hay marca seleccionada o si la marca es diferente
          if (!prev.brand || prev.brand !== mappedBrand) {
            const updated = { ...prev, brand: mappedBrand };
            // Actualizar el canal DESOL con la marca seleccionada
            defineChannel(mappedBrand, prev.acquisition);
            // Guardar la marca seleccionada en sessionStorage para que persista en el modal de WhatsApp
            const brandMapping = {
              FORD: "ford",
              FIAT: "fiat",
              PEUGEOT: "peugeot",
              JEEP: "jeep",
              HYUNDAI: "hyundai",
              GAC: "gac",
            };
            const brandLower = brandMapping[mappedBrand] || mappedBrand.toLowerCase();
            sessionStorage.setItem("selectedBrand", brandLower);
            return updated;
          }
          return prev;
        });
      }
    }
  }, [utm_brand, brand_param]);

  return (
    <>
      {/* Show the form if we're not loading or done */}
      {status === null && (
        <>
          <h5 className="pb-3">Dejanos tu consulta y te asesoramos</h5>
          <Form onSubmit={onSubmit} noValidate validated={validated}>
            {/* Nombre y Apellido */}
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>
                Nombre y apellido<span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Tu nombre"
                name="name"
                value={toSend.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            {/* Correo Electrónico */}
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>
                Correo Electrónico<span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                name="email"
                type="email"
                placeholder="email@email.com"
                value={toSend.email}
                onChange={handleChange}
                required
                isInvalid={!!errors.email && toSend.email}
              />

              <Form.Control.Feedback type="invalid" style={{ fontSize: "12px" }}>
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            {/* N° de celular */}
            <Form.Group className="mb-3" controlId="formPhone">
              <Form.Label>
                N° de celular<span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                name="phone"
                type="text"
                placeholder="351 X XXXXXX"
                value={toSend.phone}
                onChange={handleChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                required
                minLength={10}
                maxLength={10}
                isInvalid={!!errors.phone && toSend.phone}
                onKeyDown={handleKeyDown}
              />
              {/* <Form.Text className="text-muted">Código de área (sin 0 y sin 15).</Form.Text> */}
              <Form.Control.Feedback type="invalid" style={{ fontSize: "12px" }}>
                {errors.phone}
              </Form.Control.Feedback>
            </Form.Group>

            {/* ¿Qué marca te interesa? */}
            <Form.Group className="mb-3" controlId="formBrand">
              <Form.Label>
                ¿Qué marca te interesa?<span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Select name="brand" value={toSend.brand} onChange={handleChange} required>
                <option value="" disabled>
                  Elegí una marca
                </option>
                <option value="FIAT">FIAT</option>
                <option value="FORD">FORD</option>
                <option value="GAC">GAC</option>
                <option value="PEUGEOT">PEUGEOT</option>
                <option value="HYUNDAI">HYUNDAI</option>
                <option value="JEEP">JEEP</option>
              </Form.Select>
            </Form.Group>

            {/* Submit button */}
            <Button
              type="submit"
              className="btn-black w-100"
              disabled={
                !toSend.name ||
                !toSend.phone ||
                !toSend.email ||
                !toSend.brand ||
                errors.email !== "" ||
                errors.phone !== ""
                  ? true
                  : false
              }
            >
              Enviar
            </Button>
          </Form>
        </>
      )}

      {/* Loading state */}
      {status === "cargando" && (
        <div className="msgHeader text-center pt-5 pb-5" id="enviando-mensaje">
          <img src={loadingImg} alt="Cargando..." className="pb-3" style={{ maxWidth: "150px" }} />
          <p>Estamos procesando tu consulta...</p>
        </div>
      )}

      {/* Success state */}
      {status === "ok" && (
        <div className="msgHeader text-center pt-5 pb-5" id="mensaje-enviado">
          <div>
            <img src={check} alt="Enviado" className="img-fluid" style={{ marginBottom: "20px", maxWidth: "60px" }} />
            <p
              style={{
                fontWeight: "bold",
                fontSize: "22px",
                marginBottom: "0",
                textAlign: "center",
              }}
            >
              Gracias por enviarnos tu consulta.
            </p>
            <p style={{ textAlign: "center" }}>Nos pondremos en contacto con vos lo antes posible.</p>
          </div>
        </div>
      )}

      {/* Error state */}
      {status === "error" && (
        <div className="msgHeader pt-5 pb-5" id="mensaje-error">
          <div>
            <p
              style={{
                color: "red",
                fontWeight: "bold",
                fontSize: "22px",
                marginBottom: "0",
                textAlign: "center",
              }}
            >
              Se ha producido un error
            </p>
            <p style={{ textAlign: "center" }}>Vuelva a intentarlo más tarde</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Formulario;

